import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { GradeLevel } from '@app/infrastructure/models/grade-level';
import { GradeUnitListItemDTO } from '@app/infrastructure/models/grade-unit/grade-unit';
import { StatusEnum } from '@app/infrastructure/models/status';
import { ActivatedRoute, Router } from '@angular/router';
import { UserStateService } from '@app/infrastructure/core/services/state/user-state.service';

@Component({
  selector: 'app-grade-unit-card',
  templateUrl: './grade-unit-card.component.html',
  styleUrls: ['./grade-unit-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GradeUnitCardComponent implements OnInit {
  @Input() classroomId: string;
  @Input() gradeUnitListItem: GradeUnitListItemDTO;
  @Input() startDate: string;
  @Input() showImageData: boolean = true;
  @Input() showImageStatus: boolean = true;
  @Input() isGrades: boolean = false;
  gradeUnitDaysLink: string;
  unitNumber: number = 0;
  unitId: number = 0;
  public gradeNumber: string = 'k';
  public showHeader: boolean = false;
  public isTeacher = false;

  constructor(
    private router: Router,
    private userStateService: UserStateService,
  ) {
    this.userStateService.getUserSession().subscribe((user) => {
      this.isTeacher = user && !!user.teacher?.id;
    });
  }

  ngOnInit(): void {
    this.unitNumber = this.gradeUnitListItem?.unitNumber;
    this.unitId = this.gradeUnitListItem?.unitId;
    this.gradeNumber = this.getGrade(this.gradeUnitListItem?.unitGradeLevel);
    this.gradeUnitDaysLink = `${this.unitNumber}/days`;

    // TODO: Delete dummy code below here once real status assigned
    this.gradeUnitListItem.status =
      Math.random() >= 0.5 ? StatusEnum.READY : StatusEnum.INPROGRESS;
  }

  getGrade(gradeEnumeration): string {
    const keys: string[] = Object.keys(GradeLevel);
    const val = keys.find((k) => GradeLevel[k] === gradeEnumeration);

    switch (val) {
      case 'KINDERGARTEN':
        return 'k';
      case 'FIRST':
        return '1';
      case 'SECOND':
        return '2';
      case 'THIRD':
        return '3';
      case 'FOURTH':
        return '4';
      case 'FIFTH':
        return '5';
      case 'SIXTH':
        return '6';
    }
    return '0';
  }

  doClick() {
    localStorage.setItem('STEMTaughtGradeSelection', this.gradeNumber);
    if (!this.router.url.includes('/days')) {
      let route: string;
      if (!this.router.url.includes('/grading')) {
        route = `${this.router.url}/${this.unitNumber}/days`;
      } else {
        route = `${this.router.url}/${this.unitId}/unit-grading`;
      }

      this.router.navigateByUrl(route);
    }
    // this.router.navigate([route], {
    //   state: {
    //     classroomId: this.classroomId,
    //     gradeNumber: this.gradeNumber,
    //     unitNumber: this.unitNumber,
    //   },
    // });
  }

  isAssigned(): boolean {
    return !(this.gradeUnitListItem?.status === StatusEnum.UNASSIGNED);
  }

  getTitle(): string {
    return this.gradeUnitListItem?.unitTitle;
  }

  getDescription(): string {
    return this.gradeUnitListItem?.unitDescription;
  }

  getStatus(): string {
    return this.gradeUnitListItem?.status?.toLocaleUpperCase();
  }

  getStartDate(): string {
    return this.isAssigned() ? `START - ${new Date().toDateString()}` : '';
  }

  getImgSrc(): string {
    return this.gradeUnitListItem?.unitCoverImageUrl;
  }

  getAlt(): string {
    return `STEMTaught ${this.gradeUnitListItem?.unitGradeLevel} Unit ${this.gradeUnitListItem?.unitNumber}`;
  }

  getStyles() {
    // Force status to ready for the time being since we don't actually show the status text, but want to keep the Unit title and styling
    const status = 'ready';
    let back: string = '';
    let fore: string = '';

    if (status === 'ready') {
      back = '#e8f4d4';
      fore = '#537917';
    } else if (status === 'in-progress') {
      back = '#ffeab0';
      fore = '#665117';
    }

    const myStyles = {
      backgroundColor: back,
      color: fore,
    };
    return myStyles;
  }
}
